import React, { useState } from "react";
import contactStoreData from "Stores/contactData";
import ContactUploadErrorIcon from "Assets/png/contactUploadError.png";
import Button from "Components/common/Button";
import { confirmationPopupState } from "Components/common/confirmationPopup";

const FieldValidatorMsgPopup = props => {
  const {
    fieldResponse,
    close,
    data,
    skipAndAddContactCbk = () => {},
    title = "Add Contacts",
    isCustomTask = false,
    isSequence = false,
    back = () => {}
  } = props;
  const {
    missingFields = [],
    uploadedCount = 0,
    validCount = 0
  } = fieldResponse;

  const [skipLoader, setSkipLoader] = useState(false);

  const getMessage = () => {
    if (fieldResponse && Object.keys(fieldResponse).length) {
      return validCount === 0
        ? constructAllFieldsMissingDom()
        : partialiFieldsMissingDom();
    }
  };

  const constructAllFieldsMissingDom = () => {
    const missingFieldsLen = missingFields?.length || 0;
    if (missingFieldsLen) {
      const msg = uploadedCount > 1
        ? `${uploadedCount} of the uploaded contacts don't have the following mandatory field(s):`
        : `The uploaded contact doesn't have the following mandatory field(s):`;
      return (
        <div className="allFieldsMissingCont">
          <div className="messageCont">
            <div className="message">{msg}</div>
            {getMissingFieldsDom(missingFields)}
          </div>
        </div>
      );
    }
  };

  const toRoman = num => {
    const vals = [1000,900,500,400,100,90,50,40,10,9,5,4,1];
    const syms = ["M","CM","D","CD","C","XC","L","XL","X","IX","V","IV","I"];
    let result = "";
    for (let i = 0; i < vals.length; i++) {
      while (num >= vals[i]) { result += syms[i]; num -= vals[i]; }
    }
    return result;
  };

  const getMissingFieldsDom = (missingFields = []) => {
    const missingFieldsLen = missingFields.length;
    return (
      <div className="missingFieldsCont">
        {missingFields &&
          missingFields.map((value, index) => {
            return (
              <span key={`missingField ${index}`} className="missingField">
                <span className="indexValue"> {toRoman(index + 1)}.&nbsp;</span>
                <span className="value">{value}</span>
              </span>
            );
          })}
      </div>
    );
  };

  const partialiFieldsMissingDom = () => {
    const missingFieldsLen = missingFields?.length || 0;
    const invalidContactCount = Math.abs(uploadedCount - validCount);

    let customTaskMsg = `${invalidContactCount} of the uploaded contacts don't have the following mandatory field(s):`;
    let msg =
      missingFieldsLen > 0
        ? `<b>${invalidContactCount}</b> of the uploaded contacts don't have the following mandatory field(s):`
        : `You have <b>uploaded ${uploadedCount} ${uploadedCount > 1 ? "contacts" : "contact"}</b> with <b>${invalidContactCount}</b> duplicate ${invalidContactCount > 1 ? "entries" : "entry"}`;

    return (
      <div className="partialFieldsMissingCont">
        <div className="messageCont">
          <div
            className="message"
            dangerouslySetInnerHTML={{
              __html: isCustomTask ? customTaskMsg : msg
            }}
          />
          {getMissingFieldsDom(missingFields)}
        </div>
      </div>
    );
  };

  const getSkipContactBtn = () => {
    const {
      validEmails = "",
      missingFields = [],
      uploadedCount = 0,
      validCount = 0
    } = fieldResponse || {};
    const invalidContactCount = Math.abs(uploadedCount - validCount);
    const missingFieldsLen = missingFields?.length || 0;

    const cancelUpload = () => {
      confirmationPopupState.setPopupValues({
        content:
          "Are you sure you want to cancel this upload?<br> Any changes made will be lost.",
        actionBtnText: "Yes",
        callback: close
      });
      confirmationPopupState.setShowPopup(true);
    };

    const skipAndUpload = async () => {
      setSkipLoader(true);
      const { contacts = [], payload = {} } = data || {};
      const { contactIds = [] } = payload || {};
      const dataObj = data || {};
      let newContacts =
        (contacts.length &&
          contacts.filter(item => validEmails.indexOf(item.email) !== -1)) ||
        [];
      let newContactIds =
        (newContacts.length &&
          newContacts
            .filter(item => validEmails.indexOf(item.email) !== -1)
            .map(obj => obj.id)) ||
        [];
      if (!contactIds || contactIds?.length === 0) {
        delete dataObj.payload.filter;
        dataObj.payload.totalCount = newContactIds?.length || 0;
      }
      dataObj.contacts = newContacts;
      dataObj.payload.contactIds = newContactIds;
      let resData = await contactStoreData.validateDailyLimitForContacts(
        dataObj?.payload || {},
        isSequence
      );
      resData && skipAndAddContactCbk({ ...dataObj, ...resData });
      setSkipLoader(false);
    };

    return (
      <>
        <div className="cancelText">
          You can{" "}
          <span className="canceLink" onClick={e => cancelUpload(e)}>
            cancel
          </span>{" "}
          the upload, add the missing fields and upload again
        </div>
        <div className="orText">(or)</div>
        <div className="btnCont">
          <Button
            id="skipAndUploadContact"
            name="skipAndUploadContact"
            type="button"
            btnText={`Skip the ${
              missingFieldsLen > 0
                ? `contact${
                    invalidContactCount > 1 ? "s" : ""
                  } with missing fields`
                : `duplicate contact${invalidContactCount > 1 ? "s" : ""}`
            } and proceed`}
            className={`skipAndUploadContact ${skipLoader ? "loading" : ""}`}
            loader={skipLoader}
            click={skipAndUpload}
          />
        </div>
      </>
    );
  };

  const getOkContactBtn = () => {
    let textPlural = (missingFields?.length > 1 && "s") || "";

    return (
      <>
        <div className="reuploadMsg">
          Please update your Contact{textPlural} with the missing field
          {textPlural} and try again
        </div>
        <div className="btnCont">
          <Button
            id="reUploadContact"
            name="reUploadContact"
            type="button"
            className="reUploadContact"
            btnText="Ok"
            loader={false}
            click={close}
          />
        </div>
      </>
    );
  };

  return (
    <div className="fieldValidatorMsgPopup">
      <div className="fieldValidatorMsgCard">
        <h3>{title}</h3>
        <div className="cardContent">
          <img
            src={ContactUploadErrorIcon}
            alt=""
            className="contactErrorIcon"
          />
          <div className="errorMessage">
            {getMessage()}
            {fieldResponse && (
              <div className="bottomCont">
                {validCount > 0 ? getSkipContactBtn() : getOkContactBtn()}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="fieldValidatorOverlay" />
    </div>
  );
};

export default FieldValidatorMsgPopup;
